import { useContext, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Grid, LinearProgress, Typography } from '@mui/material';
import { RemessasContext } from 'contexts/RemessasContext';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { CustomPagination } from 'utils/functions';
import { useDialog } from '..';
import Button from 'components/Button';
import localeText from 'utils/localeText';

const MaletaModal = ({ row }) => {
  const { postLoading, postDocumento } = useContext(DocumentosContext);
  const { getLoading, getMaleta } = useContext(RemessasContext);
  const [selected, setSelected] = useState([]);
  const [itens, setItens] = useState([]);
  const { closeDialog } = useDialog();

  const loading = getLoading || postLoading;

  const onSubmit = () => {
    const itensSelecionados = itens
      .filter((item) => selected.includes(item.id))
      .map((item) => ({
        ...item,
        quantidade_inserir: Number(item.quantidade_inserir || 0),
      }));

    const data = {
      Itens: itensSelecionados?.map((item) => ({
        documento_id: row?.id,
        descricao: item?.descricao,
        produto_id: item?.produto_id,
        referencia: item?.referencia,
        unidade_medida_id: item?.unidade_medida_id,
        preco: item?.preco,
        quantidade: Number(item?.quantidade_inserir || 0),
        Origens: [{ documento_item_org_id: item?.id }],
      })),
    };

    postDocumento({ data, cb: closeDialog });
  };

  const onCellEditCommit = (e) => {
    const value = Number(e?.value || 0);

    setItens((prev) =>
      prev.map((item) => {
        if (item?.id !== e?.id) {
          return item;
        }

        if (e?.field !== 'quantidade_inserir') {
          return {
            ...item,
            [e?.field]: e?.value,
          };
        }

        const quantidade = Math.min(
          Math.max(value, 0),
          Number(item?.quantidade_maxima || 0)
        );

        return {
          ...item,
          quantidade_inserir: quantidade,
        };
      })
    );
  };

  useEffect(() => {
    getMaleta({
      cb: (res) =>
        setItens(
          res?.map((m) => {
            const qt =
              (m?.quantidade || 0) -
              (m?.quantidade_usada || 0) -
              (m?.quantidade_retornada || 0);
            return { ...m, quantidade_maxima: qt, quantidade_inserir: qt };
          })
        ),
    });
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Itens da Maleta</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography color="text.secondary">
          Selecione os itens que deseja inserir na Ordem de Serviço Nº{' '}
          {row?.documento}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={itens}
          columns={[
            {
              field: 'referencia',
              headerName: 'Referência',
              width: 200,
              sortable: false,
            },
            {
              field: 'descricao',
              headerName: 'Descrição',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'quantidade',
              headerName: 'Quantidade Total',
              type: 'number',
              width: 200,
              sortable: false,
            },
            {
              field: 'quantidade_usada',
              headerName: 'Quantidade Utilizada',
              type: 'number',
              width: 200,
              sortable: false,
            },
            {
              field: 'quantidade_retornada',
              headerName: 'Quantidade Retornada',
              type: 'number',
              width: 200,
              sortable: false,
            },
            {
              field: 'quantidade_inserir',
              headerName: 'Quantidade a Inserir',
              type: 'number',
              width: 200,
              sortable: false,
              editable: true,
            },
          ]}
          checkboxSelection
          selectionModel={selected}
          onSelectionModelChange={(ids) => setSelected(ids)}
          isCellEditable={(params) =>
            params.field === 'quantidade_inserir' &&
            selected.includes(params.id)
          }
          autoHeight
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          onCellEditCommit={onCellEditCommit}
          components={{
            LoadingOverlay: LinearProgress,
            Pagination: CustomPagination,
          }}
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          color="primary"
          loading={loading}
          onClick={onSubmit}
          variant="contained"
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default MaletaModal;
